module.exports = __webpack_public_path__ + "img/Sports.07c4b82f.jpg";